import React, { useEffect, useState ,useRef} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import tableToExcel from '../../excel-downloads/tableToExcel';

const handleDownload = () => {
  tableToExcel('FPSReport', 'My Worksheet');
};
// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const KeyRegisterAllotFPS_data = async (parms) => {
  const response = await fetch(`${process.env.REACT_APP_URL_ALLOTMENT}/SchemeAllotmentAll/get_Scheme_Allot_All_FPS`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const SchemeAllotAllFPS = ({ month, year,  dist_code, afso_code }) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const fpstab = useRef(null); // Use ref to scroll to this div
  const [totals, setTotals] = useState([]);
 
  const calculateTotals = (data) => {
    const columnCount = data[0].c_lst.length;
    const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

    data.forEach(item => {
        item.c_lst.forEach((colItem, colIndex) => {
            columnTotals[colIndex] += parseFloat(colItem.qty_1) ||0; 
        });
    });

    setTotals(columnTotals); // Set the totals in state
};

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await KeyRegisterAllotFPS_data({ month, year,  dist_code, afso_code });

        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {

          setReportData(response_data.data);
          calculateTotals(response_data.data); 

        } else {
          setReportData([]);
        }

      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year,  dist_code,afso_code]);


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpstab.current) {
      fpstab.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
    }
}, [loading, error, reportData]);

if (loading) {
  return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
      <CircularProgress />
  </Box></div>
}if (error) {
  return <div class="mainhead" align="center">
  Internal Error
  </div>
}

  if (reportData.length === 0) {
    return <div className="mainhead" align="center">
No data found 
</div>
  } 

  const S_totals = reportData.reduce(
    (acc, item) => {
       acc.total_cards += item.total_cards || 0;
      acc.total_units += item.total_units || 0;
      return acc;
    },
    {
       total_cards: 0,
      total_units: 0,
    }
  );
  return (
    <>
<div align="right"><button type="button" class="button button2" onClick={handleDownload}>Export to Excel</button>
            </div>
            {/* <br/> */}
      <table ref={fpstab}  align="center" width="90%" border={1} id="FPSReport">
        <thead>
          <tr className="tableheader">
          <th colSpan={4+reportData[0].c_lst.length + reportData[0].s_lst.length}>{tabHeading}</th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={2}>Sl.No</th>
            <th rowSpan={2}>FPS</th>
            <th rowSpan={2}>Total Cards</th>
                        <th rowSpan={2}>Total Unit</th>
                        {
                reportData[0].s_lst.map((item,index)=>(
                                  <th colSpan={reportData[0].c_lst.length/reportData[0].s_lst.length}>{item.scheme_short_name}</th>
                ))}
                    </tr>
                    <tr className="tableheader">
                    {
                reportData[0].c_lst.map((item,index)=>(
                                  <th >{item.comm_name_en}<br/>({item.unit_type}) </th>
                ))}
          </tr>
        </thead>
        <tbody>
          { 
 
            reportData.map((item, index) => (

              <tr key={item.fps_id}>
                <td>{index + 1}</td>
                <td style={{ textAlign: 'left' }}>{item.fps_id}</td>
                <td style={{ textAlign: 'right' }}>{item.total_cards}</td>
                                <td style={{ textAlign: 'right' }}>{item.total_units}</td>
                                {
                item.c_lst.map((item1,index)=>(
                    <td style={{ textAlign: 'right' }}>{item1.qty_1}</td> 
                ))}
                </tr>
              )) 
           }
          
        </tbody>
        <tfoot>
                    <tr className="tableheader">
                        <td colSpan={2}>Total</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{S_totals.total_cards}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{S_totals.total_units}</td>
                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}
                    </tr>
                </tfoot>
      </table>
      <br /><br />
      <br /><br />

    </>
  );
};

export default SchemeAllotAllFPS;
